module.exports = __webpack_public_path__ + "assets/img/组 162@2x.367cfe47.png";